import {resetPasswordTypes} from "../../actions/AuthActions/AuthActionsTypes/ResetPasswordActionsTypes";

const initSignInState = {
    loading: false,
    success: false,
    verified: false,
};

/**
 *
 * @param state
 * @param action
 * @returns {object}
 * @constructor
 */
const ResetPasswordReducer = (state = initSignInState, action) => {
    switch (action.type) {
        case resetPasswordTypes.RESET_PASSWORD_REQUEST: {
            return Object.assign({}, state, {
                loading: true,
                success: false,
            });
        }

        case resetPasswordTypes.RESET_PASSWORD_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                success: true,
            });
        }

        case resetPasswordTypes.RESET_PASSWORD_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                success: false,
            });
        }

        default: {
            return state;
        }
    }
};

export default ResetPasswordReducer;
